import { useLoggedIn } from 'bv-hooks';
import CenterContentView from './center_content_view';

const CenterContentRedux = () => {
  const loggedIn = useLoggedIn();

  return (
    <CenterContentView
      loggedIn={loggedIn}
    />
  );
};

export default CenterContentRedux;
